import styled from "@emotion/styled";

import { commonColors } from "application/theme";

export const Wrapper = styled("main")`
  display: flex;
  flex-direction: column;
  padding: 12px 16px 40px;
  background: ${commonColors.grey100};
  height: 100%;
  overflow-x: auto;

  .divider {
    margin: 40px 0;
  }

  .confirm-pop-up-buttons-section {
    margin-top: 16px;
  }
`;

export const HeaderStyled = styled("header")`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  margin-bottom: 12px;

  button {
    all: unset;
    box-sizing: border-box;
    cursor: pointer;

    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;

    color: ${commonColors.grey900};
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 130%;
    letter-spacing: 0.07px;
  }
`;

export const IconStyled = styled("div")`
  display: flex;
  width: 48px;
  height: 48px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  border: 1px solid ${commonColors.white};
  background: ${commonColors.white400};

  svg {
    width: 24px;
    height: 24px;

    path {
      fill: ${commonColors.grey900};
    }
  }
`;

export const InfoSection = styled("div")`
  display: flex;
  flex-direction: column;
  gap: 16px;
  p {
    color: ${commonColors.grey900};
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%;
    letter-spacing: 0.08px;
  }
`;

export const Title = styled("div")`
  background: ${commonColors.lemonPie};
  color: ${commonColors.grey900};
  font-size: 24px;
  font-weight: 500;
  line-height: 130%;
`;

export const MinimalInvestment = styled("div")`
  margin: 12px 0 20px 0;
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;

  > p {
    width: 100%;
    color: ${commonColors.grey900};
    font-family: Unica77;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 130%;
    letter-spacing: 0.07px;
  }

  > h3 {
    min-width: fit-content;
    color: ${commonColors.grey900};
    font-family: Unica77;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: 0.08px;
  }
`;

export const IconWrapper = styled("div")`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 32px;
  min-width: 32px;
  height: 32px;
  min-height: 32px;
  border-radius: 200px;
  background: ${commonColors.white};

  > svg {
    width: 20px;
    height: 20px;
  }
`;
